import { ArrowRight } from "lucide-react";
import TalkToMarketSection from "./TalkToMarketSection";
import KnowledgeGraphSection from "./KnowledgeGraphSection";
import StrategiesIntroSection from "./StrategiesIntroSection";
import MotivationSection from "./MotivationSection";
import AchievementSection from "./AchievementSection";
import PoweredBySection from "./PoweredBySection";
// import IntroduceSection from "./IntroduceSection";
import { Header } from "../../features/kquant/components/Header";
import { Link } from "react-router-dom";

export default function HomePage() {
  return (
    <div className="flex flex-col">
      <div className="relative overflow-hidden bg-gradient-to-b from-slate-50 via-white to-slate-50 text-slate-900">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -top-24 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-gradient-to-br from-cyan-200/55 via-sky-200/40 to-indigo-200/40 blur-3xl" />
          <div className="absolute -bottom-40 left-[-120px] h-[420px] w-[420px] rounded-full bg-gradient-to-br from-amber-200/55 via-orange-200/35 to-rose-200/30 blur-3xl" />
          <div className="absolute bottom-[-220px] right-[-160px] h-[520px] w-[520px] rounded-full bg-gradient-to-br from-emerald-200/40 via-lime-200/30 to-cyan-200/35 blur-3xl" />
        </div>

        <div className="relative z-50 mx-auto max-w-[1280px] px-6 md:px-8">
          <Header />
        </div>

        <main className="relative mx-auto max-w-[1280px] px-6 pb-6 pt-10 md:px-8 md:pb-10 md:pt-16">
          <div className="mx-auto max-w-6xl text-center">
            <h1 className="mt-6 text-balance text-3xl font-bold tracking-tight text-slate-900 md:text-5xl">
              LingCopilot: An LLM-Empowered <span className="text-blue-600">Multi-agents</span>
              <br />
              <span className="text-blue-600"> No-Code </span>
              Quantitative Trading System
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-pretty text-lg leading-8 text-slate-600">
              Transform your trading ideas into executable strategies in seconds. From natural language to professional-grade workflows.
            </p>

            {/* <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href="#talk-to-market"
                className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-cyan-600 to-blue-600 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-cyan-500/20 transition-all hover:from-cyan-500 hover:to-blue-500 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 sm:w-auto"
              >
                Talk To Market
              </a>

              <a
                href="#knowledge-graph"
                className="inline-flex w-full items-center justify-center rounded-full border border-slate-900/10 bg-white/70 px-6 py-3 text-sm font-semibold text-slate-800 shadow-sm transition-colors hover:bg-white sm:w-auto"
              >
                Knowledge Graph
              </a>
            </div> */}
            <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/smart-insights"
                className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-cyan-600 to-blue-600 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-cyan-500/20 transition-all hover:from-cyan-500 hover:to-blue-500 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 sm:w-auto"
              >
                Get Started
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </Link>

              <Link
                to="/my-quant-flows"
                className="inline-flex w-full items-center justify-center rounded-full border border-slate-900/10 bg-white/70 px-6 py-3 text-sm font-semibold text-slate-800 shadow-sm transition-colors hover:bg-white sm:w-auto"
              >
                Explore Quant Flows
              </Link>
            </div>
            <div className="mt-8 w-full" />
            {/* <ChatBar Icon={ArrowRight} /> */}
          </div>
        </main>

      </div>

      {/* Motivation Section */}
      <MotivationSection />

      {/* Achievement Section */}
      <AchievementSection />

      {/* <IntroduceSection /> */}

      <section id="talk-to-market">
        <TalkToMarketSection />
      </section>

      <section id="strategies">
        <StrategiesIntroSection />
      </section>


      <PoweredBySection />

      <section id="knowledge-graph">
        <KnowledgeGraphSection />
      </section>

      <footer className="relative mx-auto w-full max-w-[1280px] px-6 py-10 text-center text-xs text-slate-500 md:px-8">
        K-Quant v3.0
      </footer>
    </div>
  );
}
